const BalanceBillSkeletonLoader = () => {
  return (
    <div className="mx-6">
      {Array.from({ length: 7 }).map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between border-b border-border bg-card p-4"
        >
          {/* Left side - Submitted date skeleton loader */}
          <div className="flex animate-pulse items-center space-x-2">
            <div className="h-4 w-24 animate-pulse bg-gray-300" />{" "}
            {/* "Submitted:" */}
            <div className="h-4 w-32 animate-pulse bg-gray-300" /> {/* Date */}
          </div>

          {/* Right side - Action buttons skeleton loader */}
          <div className="flex animate-pulse items-center space-x-3">
            <div className="h-9 w-16 animate-pulse rounded-md bg-gray-300" />{" "}
            {/* View button */}
            <div className="h-9 w-20 animate-pulse rounded-md bg-gray-300" />{" "}
            {/* Delete button */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BalanceBillSkeletonLoader;
